import React, { useState, useEffect } from "react";
import {
  ThemeProvider,
  Typography,
  Box,
  Card,
  CardHeader,
  CardContent,
  Breadcrumbs,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  CircularProgress,
} from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import WeekendIcon from "@mui/icons-material/Weekend";
import { createTheme } from "@mui/material/styles";
import { getTechnicians } from "../API/technicianAPI";
import BaseWrapper from "../../components/shared/BaseWrapper";

const theme = createTheme({
  palette: {
    primary: {
      main: "#1e5d45", // Custom primary color
    },
  },
});

const days = ["Monday", "Tuesday", "Wednesday", "Thursday"];

function ViewRestDay() {
  const [technicians, setTechnicians] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false); // State to manage loading
  useEffect(() => {
    (async () => {
      try {
        const fetchedTechnicians = await getTechnicians();
        setTechnicians(fetchedTechnicians);
        setLoading(false);
      } catch (error) {
        setError("Failed to fetch technicians");
        setLoading(false);
      }
    })();
  }, []);

  // Group technicians by rest day
  const groupedTechnicians = days.map((day) =>
    technicians.filter((technician) => technician.rest_day.includes(day))
  );

  // Determine the maximum number of rows needed
  const maxRows = Math.max(
    ...groupedTechnicians.map((group) => group.length),
    0
  );

  return (

    <BaseWrapper
      titleIcon={<WeekendIcon />}
      title="Operations"
      subTitle="Rest Day"
      subTitleRoute={"/view-rest-day"}
      // createButtonLabel="Add Technician"
      // onClickCreateButton={() => navigate("/add-technician")}
      successMessage={successMessage}
      setSuccessMessage={setSuccessMessage}
      errorMessage={errorMessage}
      setErrorMessage={setErrorMessage}
      isLoading={isLoading}
    >
      {loading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: 2,
            paddingBottom: "20px",
          }}
        >
          <CircularProgress />
          <Typography variant="body1" sx={{ marginLeft: 2 }}>
            Loading technicians...
          </Typography>
        </Box>
      ) : error ? (
        <Typography variant="body1" color="error" sx={{ padding: 2 }}>
          {error}
        </Typography>
      ) : (
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                {days.map((day) => (
                  <TableCell
                    key={day}
                    align="center"
                    sx={{
                      fontWeight: "bold",
                      backgroundColor: "#f5f5f5",
                    }}
                  >
                    {day}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {/* Render rows dynamically based on maxRows */}
              {Array.from({ length: maxRows }).map((_, rowIndex) => (
                <TableRow
                  key={rowIndex}
                  sx={{ backgroundColor: "#fbfbfb" }}
                >
                  {groupedTechnicians.map((group, colIndex) => (
                    <TableCell
                      key={colIndex}
                      align="center"
                      sx={{
                        verticalAlign: "top",
                      }}
                    >
                      {group[rowIndex]
                        ? `${group[rowIndex].lastname}, ${group[rowIndex].firstname}`
                        : ""}
                    </TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </BaseWrapper>

    // <ThemeProvider theme={theme}>
    //   <Box sx={{ padding: "40px 60px" }}>
    //     <Card
    //       variant="outlined"
    //       style={{
    //         marginTop: "40px",
    //         marginBottom: "40px",
    //         borderRadius: 0,
    //       }}
    //     >
    //       <CardHeader
    //         title={
    //           <Box
    //             display="flex"
    //             alignItems="center"
    //             justifyContent="space-between"
    //           >
    //             <Box display="flex" alignItems="center">
    //               <WeekendIcon
    //                 sx={{
    //                   fontSize: "40px",
    //                   marginRight: "8px",
    //                 }}
    //               />
    //               <Typography variant="h6">Operations</Typography>
    //             </Box>
    //             <Breadcrumbs
    //               aria-label="breadcrumb"
    //               separator={<NavigateNextIcon fontSize="small" />}
    //               sx={{ color: "white" }}
    //             >
    //               <Typography sx={{ color: "#ffffff99" }}>
    //                 Operations
    //               </Typography>
    //               <Typography sx={{ color: "#ffffff", textDecoration: "none" }}>
    //                 View Rest Day
    //               </Typography>
    //             </Breadcrumbs>
    //           </Box>
    //         }
    //         sx={{
    //           backgroundColor: "#1e5d45",
    //           color: "white",
    //           padding: "16px",
    //         }}
    //       />
    //       <CardContent sx={{ padding: "20px" }}>
    //         <Card variant="outlined" sx={{ padding: "20px" }}>
    //           <CardHeader
    //             title={
    //               <Typography variant="h5" sx={{ fontWeight: "bold" }}>
    //                 Rest Day
    //               </Typography>
    //             }
    //             sx={{ marginBottom: 2 }}
    //           />
    //           {loading ? (
    //             <Box
    //               sx={{
    //                 display: "flex",
    //                 justifyContent: "center",
    //                 alignItems: "center",
    //                 padding: 2,
    //                 paddingBottom: "20px",
    //               }}
    //             >
    //               <CircularProgress />
    //               <Typography variant="body1" sx={{ marginLeft: 2 }}>
    //                 Loading technicians...
    //               </Typography>
    //             </Box>
    //           ) : error ? (
    //             <Typography variant="body1" color="error" sx={{ padding: 2 }}>
    //               {error}
    //             </Typography>
    //           ) : (
    //             <TableContainer>
    //               <Table>
    //                 <TableHead>
    //                   <TableRow>
    //                     {days.map((day) => (
    //                       <TableCell
    //                         key={day}
    //                         align="center"
    //                         sx={{
    //                           fontWeight: "bold",
    //                           backgroundColor: "#f5f5f5",
    //                         }}
    //                       >
    //                         {day}
    //                       </TableCell>
    //                     ))}
    //                   </TableRow>
    //                 </TableHead>
    //                 <TableBody>
    //                   {/* Render rows dynamically based on maxRows */}
    //                   {Array.from({ length: maxRows }).map((_, rowIndex) => (
    //                     <TableRow
    //                       key={rowIndex}
    //                       sx={{ backgroundColor: "#fbfbfb" }}
    //                     >
    //                       {groupedTechnicians.map((group, colIndex) => (
    //                         <TableCell
    //                           key={colIndex}
    //                           align="center"
    //                           sx={{
    //                             verticalAlign: "top",
    //                           }}
    //                         >
    //                           {group[rowIndex]
    //                             ? `${group[rowIndex].lastname}, ${group[rowIndex].firstname}`
    //                             : ""}
    //                         </TableCell>
    //                       ))}
    //                     </TableRow>
    //                   ))}
    //                 </TableBody>
    //               </Table>
    //             </TableContainer>
    //           )}
    //         </Card>
    //       </CardContent>
    //     </Card>
    //   </Box>
    // </ThemeProvider>
  );
}

export default ViewRestDay;
